import { call } from 'redux-saga/effects';
import { websocketFetch } from 'common/websocket-redux';

export const refundClaim = payload =>
  call(websocketFetch, 'refund_claim', payload);
